<template>
  <rest-form-page
    :page-title="pageTitle"
    :fetch-endpoint="fetchEndpoint"
    :save-endpoint="saveEndpoint"
    :after-save="afterSave"
    :model="model"
    :rules="rules"
    :readonly="readonly"
  >
    <template slot="form" v-if="model">
      <form-section>
        <el-row>
          <el-col :span="12">
            <rest-form-item :label="$t('Events_Field_Title')" prop="title">
              <el-input v-model="model.title" :disabled="!isCreatePage" />
            </rest-form-item>
          </el-col>

          <el-col :span="12">
            <rest-form-item :label="$t('Events_Field_Event')" prop="type">
              <el-input v-model="model.type" :disabled="true" />
            </rest-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <rest-form-item
              prop="store_event_hit"
              :label="$t('Events_Field_StoreEventHit')"
            >
              <el-switch v-model="model.store_event_hit"></el-switch>
            </rest-form-item>
          </el-col>
        </el-row>
      </form-section>
    </template>
  </rest-form-page>
</template>

<script>
import RestFormPage from '@/common/components/rest/RestFormPage'
import RestFormItem from '@/common/components/rest/RestFormItem'
import FormSection from '@/common/components/form/FormSection'
import { projectEndpoint, projectRoute } from '@/core/helpers'

export default {
  name: 'EventFormPage',

  components: {
    RestFormPage,
    RestFormItem,
    FormSection
  },

  props: {
    readonly: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      model: this.defaultModel()
    }
  },

  computed: {
    pageTitle() {
      return this.$t(this.$route.meta.title)
    },

    fetchEndpoint() {
      if (this.$route.query.id) {
        return projectEndpoint({
          method: 'get',
          url: `events/${this.$route.query.id}`,
          handler: data => {
            this.model = {
              ...data,
              title: data.name
            }
          }
        })
      } else {
        return null
      }
    },

    saveEndpoint() {
      if (this.$route.query.id) {
        return projectEndpoint({
          method: 'patch',
          url: `events/${this.$route.query.id}`
        })
      } else {
        return projectEndpoint({
          method: 'post',
          url: `events`
        })
      }
    },

    rules() {
      return {
        title: {
          required: true
        },
        type: {
          required: true
        }
      }
    },

    isCreatePage() {
      return !this.$route.query.id
    }
  },

  methods: {
    defaultModel() {
      if (this.$route.query.id) {
        return null
      } else {
        return {
          type: 'custom',
          store_event_hit: 1
        }
      }
    },

    afterSave() {
      this.$router.push(
        projectRoute({
          name: 'EventList'
        })
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/events/pages/EventFormPage.vue